package it.neckar.lizergy.model.configuration.components

import kotlinx.serialization.Serializable

/**
 * Where the control technology required by § 14a EnWG is integrated.
 *
 * At most one of the two integrations can be selected.
 */
@Serializable
enum class EnWG14aIntegrationType(
  /**
   * The headline of the quote position and of the entry in the "Sonstige Arbeiten" of the assembly portfolio.
   * `null` if no integration is selected.
   */
  val quoteHeadline: String?,
) {
  /**
   * No § 14a EnWG integration
   */
  None(null),

  /**
   * "§ 14a EnWG Integration in Zählerschrank"
   */
  InZaehlerschrank("Zählerschrankanpassung nach § 14a EnWG"),

  /**
   * "§ 14a EnWG Integration in einem separaten Aufputzgehäuse"
   */
  InAufputzgehaeuse("Zählerschrankanpassung in einem separaten Aufputzgehäuse nach § 14a EnWG"),
}
